import React from 'react';

import Facebook from '../../assets/facebook.svg';
import Twitter from '../../assets/twitter.svg';
import Instagram from '../../assets/insta.svg';

import Phone from '../../assets/whiteMobile.svg';
import Clock from '../../assets/whiteClock.svg';
import Location from '../../assets/location.svg';

const Footer = () => {

    const facebookLink = 'https://www.facebook.com';
    const twitterLink = 'https://www.twitter.com';
    const instagramLink = 'https://www.instagram.com';

    return (
        <div className='w-full h-full flex justify-center items-center text-white'>
            <div className='w-[80vw] h-full pt-2'>
                {/*
                <div className='w-full h-[90%] flex flex-col lg:flex-row justify-between items-center gap-10'>
                    <div className='w-full lg:w-[20%] h-[45%] lg:h-full flex flex-col justify-start items-start gap-2'>
                        <h1 className='text-xl font-bold'>About Us</h1>
                        <p>
                            From exotic sports cars to luxury sedans and SUVs, Instant Luxury Rentals features one of the largest selections of exotic and premium luxury vehicles from manufacturers around the world including Lamborghini, Bugatti, Aston Martin, Jaguar, Alfa Romeo, BMW, Mercedes-Benz, Audi, Koenigsegg, Tesla, Ferrari, Maserati, Porsche, Bentley, Range Rover, Rolls-Royce, Land Rover, Cadillac, Fiat, McLaren, Mini, Lexus, Tata Motors, Peugeot, Pagani and more.
                        </p>
                    </div>
                    <div className='w-full lg:w-[20%] h-[45%] lg:h-full flex flex-col justify-center items-start gap-2'>
                        <div className='w-full h-1/2 flex flex-col justify-start items-start'>
                            <h1 className='text-xl font-bold'>Contact Information</h1>
                            <ul className='flex flex-col justify-start items-start gap-2 pt-5'>
                                <li className='flex gap-1 justify-start items-start'>
                                    <img src={Phone} alt="phone" width={20} className='mt-1' />
                                    1-877-736-8553
                                </li>
                                <li className='flex gap-1 justify-start items-start'>
                                    <img src={Location} alt="location" width={20} className='invert mt-1' />
                                    Instant Luxury Rentals
                                    2630 W Broward Blvd Ste 203-743 <br />
                                    Fort Lauderdale, FL 33312
                                </li>
                                <li className='flex gap-1 justify-start items-start'>
                                    <img src={Clock} alt="clock" width={20} className='mt-1' />
                                    Mon - Sun 8:00am - 8:00pm
                                </li>
                            </ul>
                        </div>
                        <div className='w-full h-1/2 flex justify-start items-start pt-5'>
                            <ul className='flex justify-start items-center gap-3'>
                                <li
                                    onClick={() => {
                                        window.open(facebookLink, "_blank");
                                    }}
                                    className='hover:cursor-pointer bg-blue-700 rounded-full p-2'><img src={Facebook} alt="facebook" width={25} className='invert' /></li>
                                <li
                                    onClick={() => {
                                        window.open(twitterLink, "_blank");
                                    }}
                                    className='hover:cursor-pointer bg-blue-400 rounded-full p-2'><img src={Twitter} alt="facebook" width={25} className='invert' /></li>
                                <li
                                    onClick={() => {
                                        window.open(instagramLink, "_blank");
                                    }}
                                    className='hover:cursor-pointer bg-blue-500 rounded-full p-2'><img src={Instagram} alt="facebook" width={25} className='invert' /></li>
                            </ul>
                        </div>
                    </div>
                    <div className='hidden lg:flex w-full lg:w-[20%] h-full flex-col justify-start items-start gap-2'>

                    </div>
                    <div className='hidden lg:flex w-full lg:w-[20%] h-full flex-col justify-center items-start gap-2'>
                        
                    </div>
                </div>
                */}
                <div className='w-full h-[100%]'>
                    {/* <hr /> */}
                    <div className='flex flex-col lg:flex-row justify-between items-center'>
                        <div className='text-center lg:text-start w-full lg:w-1/2 flex justify-start items-center py-4'>
                            <h1>
                                ©2024 Copyright <span className='text-green-400'>BURAQ</span> Luxury Travels | All Rights Reserved.
                            </h1>
                        </div>
                        {/*
                        <div className='w-full lg:w-1/2 flex justify-end items-center'>
                            <ul className='flex justify-center lg:justify-end items-center gap-3 text-center'>
                                <li>Terms of Use</li>
                                <li>Privacy Policy</li>
                                <li>Cookie Policy</li>
                                <li>Rental Policies</li>
                            </ul>
                        </div>
                        */}
                    </div>
                </div>
            </div >
        </div >
    )
}

export default Footer;
